import { render, staticRenderFns } from "./ReviewLikeButton.vue?vue&type=template&id=4822ee71&scoped=true&"
import script from "./ReviewLikeButton.vue?vue&type=script&lang=js&"
export * from "./ReviewLikeButton.vue?vue&type=script&lang=js&"
import style0 from "./ReviewLikeButton.vue?vue&type=style&index=0&id=4822ee71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4822ee71",
  null
  
)

export default component.exports